<template>
  <div class="main">
    <Headers />
    <Layout class="layout_conten">
      <img src="@/assets/image/bg.png" class="layout_bg" />
      <div class="layout_main">
        <router-view />
      </div>
    </Layout>
  </div>
</template>
<style lang="less">
.main {
  height: 100%;

  .layout_header {
    height: 40px;
  }

  .layout_conten {
    // height: calc(100% - 40px);
    padding-top: 60px;
    box-sizing: border-box;
    height: 100%;
    // background: url("./../../assets/image/bg.png") repeat-y top center;
    .layout_bg {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
    .layout_main {
      height: 100%;
      overflow-y: auto;
      position: relative;
      z-index: 10;
    }
  }
}
</style>
<script>
import Headers from "./base/header";
export default {
  components: {
    Headers
  }
};
</script>